<template>
	<div class="main" v-title data-title="零部件基本资料">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">基本资料</h1>
						<el-button type="primary" plain size="small" class="fr" @click="handflag">编辑</el-button>
					</div>
				</div>
				<div class="formWBase">
					<el-form :model="editForm" label-width="100px" class="demo-ruleForm" v-if="flagForm==true">
						<el-form-item label="姓名 :" prop="name">
							<span v-if="editForm.name!=''">{{editForm.name}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="性别 :" prop="sex">
							<span v-if="editForm.sex!=''">{{editForm.sex}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="出生日期 :" prop="birthday">
							<span v-if="editForm.birthday!=''">{{editForm.birthday}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="公司 :" prop="Cname">
							<span v-if="editForm.Cname!=''">{{editForm.Cname}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="部门 :" prop="type">
							<template v-if="typestr.length!=''"><span class="spanbg"
									v-for="item in typestr">{{item}}</span></template>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="区域 :" prop="uni">
							<span v-if="editForm.uni!=''">{{editForm.uni}}</span>
							<span v-else>暂无</span>
						</el-form-item>
						<el-form-item label="行业 :" prop="hy">
							<span v-if="editForm.hy!=''">{{editForm.hy}}</span>
							<span v-else>暂无</span>
						</el-form-item>
					</el-form>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
						v-else-if="flagForm==false">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="ruleForm.name" class="inputW"></el-input>
						</el-form-item>
						<el-form-item label="性别" prop="sex">
							<el-radio-group v-model="ruleForm.sex">
								<el-radio label="1">男</el-radio>
								<el-radio label="2">女</el-radio>
								<el-radio label="3">保密</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="出生日期">
							<!-- prop="age"
            	<el-input v-model="ruleForm.age" class="inputW"></el-input> -->
							<el-date-picker v-model="ruleForm.birthday" type="date" value-format="yyyy-MM-dd"
								placeholder="出生日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="公司" prop="Cname">
							<el-input v-model="ruleForm.Cname" class="inputW"></el-input>
						</el-form-item>
						<el-form-item label="部门" prop="type">
							<el-checkbox-group v-model="ruleForm.type">
								<el-checkbox label="1" name="type">设计师</el-checkbox>
								<el-checkbox label="2" name="type">工程师</el-checkbox>
								<el-checkbox label="3" name="type">采购</el-checkbox>
								<el-checkbox label="4" name="type">销售</el-checkbox>
							</el-checkbox-group>
						</el-form-item>
						<el-form-item label="区域" prop="uni">
							<el-select v-model="scity.id" value-key="id" placeholder="省" size="mini"
								@change="citychange" class="linS">
								<!-- {{scitys}} -->
								<el-option v-for="item in scitys" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<!--市-->
							<el-select v-model="suni.id" value-key="id" placeholder="市" size="mini" @change="unichange">
								<el-option v-for="item in sunis" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<!--区-->
							<el-select v-model="sarea.id" value-key="id" placeholder="区" size="mini"
								v-if="uniflag==true">
								<el-option v-for="item in sareas" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="行业" value-key="id" prop="hy">
							<el-select v-model="crop.id" placeholder="请选择" size="mini" @change="cropchange"
								class="linS">
								<el-option v-for="item in crops" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-select>
							<!--二级菜单-->
							<el-select v-model="plant.id" value-key="id" placeholder="请选择" size="mini">
								<el-option v-for="pitem in plants" :key="pitem.id" :label="pitem.title"
									:value="pitem.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="txc">
							<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
						</el-form-item>
					</el-form>
					<!-- 上传头像  style="display: none;"-->
					<div class="upimgbtn">
						<img width="160px" :src="avatarURL">
						<div v-if="flagForm==true" class="pimg">
							<el-button type="text" size="small">头像</el-button>
						</div>
						<div v-else-if="flagForm==false" class="pimg">
							<el-button type="primary" size="small" @click="editAvatar">修改头像</el-button>
						</div>
					</div>
					<!-- 修改头像弹窗 -->
					<el-dialog title="修改头像" :visible.sync="editAvatarDialog" width="40%">
						<el-row type="flex" justify="center">
							<div class="cropper">
								<vueCropper ref="cropper" :img="option.img" :outputSize="option.size"
									:outputType="option.outputType" :info="option.info" :full="option.full"
									:canMove="option.canMove" :canMoveBox="option.canMoveBox"
									:original="option.original" :autoCrop="option.autoCrop"
									:autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
									:fixedBox="option.fixedBox" @realTime="realTime"></vueCropper>
							</div>
							<div class="previewBox">
								<div :style="previews.div" class="preview">
									<img :src="previews.url" :style="previews.img">
								</div>
								<el-row type="flex" justify="center">
									<el-upload action="" 
										:http-request="Upload" :show-file-list="false">
										<el-button size="mini" type="primary"> 更换头像</el-button>
									</el-upload>
								</el-row>
								<br>
								<el-row>
									<el-button icon="el-icon-plus" circle size="mini" @click="changeScale(1)">
									</el-button>
									<el-button icon="el-icon-minus" circle size="mini" @click="changeScale(-1)">
									</el-button>
									<el-button icon="el-icon-download" circle size="mini" @click="down('blob')">
									</el-button>
									<el-button icon="el-icon-refresh-left" circle size="mini" @click="rotateLeft">
									</el-button>
									<el-button icon="el-icon-refresh-right" circle size="mini" @click="rotateRight">
									</el-button>
								</el-row>
							</div>
						</el-row>
						<span slot="footer" class="dialog-footer">
							<el-button @click="editAvatarDialog = false">取 消</el-button>
							<el-button type="primary" @click="saveEditAvatar">确 定</el-button>
						</span>
					</el-dialog>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	import {
		VueCropper
	} from 'vue-cropper'
	import * as qiniu from "qiniu-js"
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
			VueCropper
		},
		data() {
			return {
				titleDec: "",
				// 个人资料hahah
				ruleForm: {
					name: '',
					sex: '2',
					'birthday': '',
					Cname: '',
					type: ['1'],
					uni: [],
					// 行业
				},
				editForm: {
					name: '',
					sex: '',
					'birthday': '',
					Cname: '',
					type: '',
					uni: '',
					hy: ''
				},
				flagForm: true,
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
					type: [{
						type: 'array',
						required: true,
						message: '请至少选择一种职业',
						trigger: 'change'
					}],
				},
				loadingplant: false,
				crop: {},
				plant: {},
				plants: [],
				crops: [],
				pid: 0,
				// 省市区
				scity: {},
				suni: {},
				sarea: {},
				scitys: [],
				sunis: [],
				sareas: [],
				uniflag: true,
				typestr: [],
				// 头像变量 "https://static.mfcad.com/lingbujian/pc-img/noavatar_big.gif"
				avatarURL: '',
				editAvatarDialog: false,
				crap: false,
				previews: {},
				option: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 1, // 剪切后的图片质量（0.1-1）
					full: true, // 输出原图比例截图 props名full
					outputType: 'png', // 裁剪生成额图片的格式
					canMove: true, // 能否拖动图片
					original: false, // 上传图片是否显示原始宽高
					canMoveBox: true, // 能否拖动截图框
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: 160, 
					autoCropHeight: 160,
					fixedBox: true // 截图框固定大小
				},
				uid: '',
				headname: '' ,//上传头像明
				postfix:'',
				evfile:'',
				basedata:''
			};
		},
		created() {
			this.handecrop(0);
			// 省市区
			this.handecity(1);
			// 获取基本资料
			this.handinfo();
		},
		methods: {
			
			// 上传头像
			editAvatar() {
				this.editAvatarDialog = true
				this.option.img = this.avatarURL
			},
			// 保存头像修改
			saveEditAvatar() {
				this.editAvatarDialog = false
				this.finish('blob')
			},
			// 放大/缩小
			changeScale(num) {
				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},
			// 左旋转
			rotateLeft() {
				this.$refs.cropper.rotateLeft();
			},
			// 右旋转
			rotateRight() {
				this.$refs.cropper.rotateRight();
			},
			dataURLtoFile(dataurl, filename) { //将base64转换为文件
			        var arr = dataurl.split(','),
			        mime = arr[0].match(/:(.*?);/)[1],
			        bstr = atob(arr[1]),
			        n = bstr.length,
			        u8arr = new Uint8Array(n);
			        while (n--) {
			        u8arr[n] = bstr.charCodeAt(n);
			       }
			      return new File([u8arr], filename, {
			      type: mime
			    });
			},
			// 保存上传图片
			finish(type) {
				//base64
				this.$refs.cropper.getCropData((data) => {
					this.basedata=data;
					//访问接口保存到数据库写这儿!
				})
				if (type === 'blob') {
					this.$refs.cropper.getCropBlob((data) => {
						this.avatarURL = window.URL.createObjectURL(data)
						//访问接口保存到数据库写这儿!
						this.$postcn('qiniu/del', {
							bucket: 'mfcad-avatar',
							key: this.uid + this.postfix
						}, this).then((res) => {
							if (res.data.code == 200) {
								this.$postcn('qiniu/token', {
									bucket: 'mfcad-avatar'
								}, this).then((res) => {
									var uptoken = res.data.token
									var date = new Date()
									var getMonth = date.getMonth() + 1
									// 用户id.png
									var key = this.uid +
										this.postfix // 上传后文件资源名以设置的 key 为主，如果 key 为 null 或者 undefined，则文件资源名会以 hash 值作为资源名。
									const config = {
										useCdnDomain: true, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
										region: qiniu.region
											.z0 // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
									}
									const putExtra = {
										fname: this.evfile.file.name, // 文件原文件名
										params: {}, // 用来放置自定义变量
										mimeType: null // 用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
									}
									const imgFile=this.dataURLtoFile(this.basedata,key)
									var observable = qiniu.upload(imgFile, key, uptoken, putExtra,config)
									observable.subscribe({
										next: (result) => {
											// 主要用来展示进度
										},
										error: (errResult) => {
											// 失败报错信息
										},
										complete: (result) => {
											this.$postcn('partshome/addheadimg', {
												headimg_fixed: this.headname
											}, this).then((res) => {
											})
										}
									})
								})
							}
						})
						
					})
				} else {
					this.$refs.cropper.getCropData((data) => {
						// console.log(333, data)
						//访问接口保存到数据库写这儿!
					})
				}
			},
			// 实时预览函数
			realTime(data) {
				this.previews = data
			},
			// 下载图片
			down(type) {
				var aLink = document.createElement('a')
				aLink.download = 'author-img'
				if (type === 'blob') {
					this.$refs.cropper.getCropBlob((data) => {
						aLink.href = window.URL.createObjectURL(data)
						aLink.click()
					})
				} else {
					this.$refs.cropper.getCropData((data) => {
						aLink.href = data;
						aLink.click()
					})
				}
			},
			// 更换头像--上传本地图片
			Upload(evfile) {
				this.evfile=evfile
				var reader = new FileReader();
				reader.onload = (e) => {
					let data;
					data = window.URL.createObjectURL(new Blob([e.target.result]))
					this.postfix = evfile.file.name.substring(evfile.file.name.lastIndexOf('.'), evfile.length)
					const exname = evfile.file.name.substring(evfile.file.name.lastIndexOf('.') + 1)
					this.headname = this.uid + this.postfix
					this.option.img = data
				}
				reader.readAsArrayBuffer(evfile.file);
			},
			handflag() {
				this.flagForm = false;
			},
			handinfo() {
				this.$postcn('partshome/LoadUserInformation', {}, this).then((res) => {
					// 加载数据
					if (res.data.msg != "暂时没有数据" && res.data.code != -4004) {
						this.editForm.name = res.data.nickname;
						if (res.data.sex == 1) {
							this.editForm.sex = '男'
						} else if (res.data.sex == 2) {
							this.editForm.sex = '女'
						} else if (res.data.sex == 3) {
							this.editForm.sex = '保密'
						}
						this.editForm.birthday = res.data.birthday;
						this.editForm.Cname = res.data.company;
						res.data.department.map((item, index) => {
							if (item == 1) {
								this.typestr.push('设计师')
							} else if (item == 2) {
								this.typestr.push('工程师')
							} else if (item == 3) {
								this.typestr.push('采购')
							} else if (item == 4) {
								this.typestr.push('销售')
							}
						})
						if (res.data.area.length == 0) {
							this.editForm.uni = res.data.province.name + '-' + res.data.city.name
						} else {
							this.editForm.uni = res.data.province.name + '-' + res.data.city.name + '-' + res.data
								.area.name;
						}
						this.avatarURL = res.data.headimg_b;
						this.uid = res.data.uid;
						this.editForm.hy = res.data.industry.title + '-' + res.data.position.title;
						// 编辑数据
						this.ruleForm.name = res.data.nickname;
						this.ruleForm.sex = res.data.sex.toString();
						this.ruleForm.birthday = res.data.birthday;
						this.ruleForm.Cname = res.data.company;
						this.ruleForm.type = res.data.department;
						this.scity = res.data.province;
						this.suni = res.data.city;
						this.sarea = res.data.area;
						this.crop = res.data.industry;
						this.plant = res.data.position;
						this.handecity(res.data.province.id, 'city');
						this.handecity(res.data.city.id, 'area');
						this.handecrop(res.data.industry.id)
					} else if (res.data.code == -4004) {
						this.$refs.loginIndex.handLogin(window.location.href)
					}
				})
			},
			handecrop(pid) {
				this.$postcn('partshome/BelongIndustry', {
					pid: pid
				}, this).then((res) => {
					if (res.status == 200) {
						if (pid == 0) {
							this.crops = res.data.data
						} else {
							this.plants = res.data.data
						}
					}
				})
			},
			cropchange(value) {
				if (value !== "") {
					this.handecrop(value);
				}
				this.plant = {}
			},
			// 省市区
			handecity(pid, type) {
				this.$postcn('partshome/wholeCountryCity', {
					pid: pid
				}, this).then((res) => {
					if (res.status == 200) {
						if (pid == 1) {
							this.scitys = res.data
						} else if (type == 'city') {
							this.sunis = res.data
						} else if (type == 'area') {
							if (res.data.length == 0) {
								this.uniflag = false
								this.sareas = []
								this.sarea = {}
							} else {
								this.uniflag = true
								this.sareas = res.data
							}
						}
					}
				})
			},
			citychange(value) {
				if (value !== "") {
					this.handecity(value, "city");
				}
				this.suni = {}
				this.sarea = {}
			},
			unichange(value) {
				if (value !== "") {
					this.handecity(value, "area");
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.scity.id == undefined || this.suni.id == undefined) {
							this.$message({
								type: 'info',
								message: '请选择区域'
							});
						} else if (this.crop.id == undefined || this.plant.id == undefined) {
							this.$message({
								type: 'info',
								message: '请选择行业'
							});
						} else {
							if (this.sarea.id == undefined) {
								this.sarea.id = 0
							}
							let params = {
								userid: Cookies.get('userid'),
								nickname: this.ruleForm.name,
								sex: this.ruleForm.sex,
								birthday: this.ruleForm.birthday,
								company: this.ruleForm.Cname,
								department: this.ruleForm.type,
								province: this.scity.id,
								city: this.suni.id,
								area: this.sarea.id,
								industry: this.crop.id,
								position: this.plant.id,
							}
							// console.log(params);
							// return false;
							this.$postcn('/partshome/personalInformation', params, this).then((res) => {
								if (res.data.code == 200) {
									this.$message({
										type: 'success',
										message: res.data.msg
									});
									this.$router.go(0)
								} else {
									this.$message({
										type: 'info',
										message: res.data.msg
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		}
	}
</script>

<style scoped>
	.item1 {
		display: inline-block;
	}

	.spanbg {
		background: #CCCCCC;
		padding: 3px 5px;
		border-radius: 3px;
		margin-right: 10px;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.formWBase {
		padding: 0px 100px;
		/* width: 600PX; */
		margin-top: 20PX;
	}

	.formWBase .demo-ruleForm {
		width: 600PX !important;
		display: inline-block;
	}

	.formWBase .el-form-item {
		width: 600PX !important;
	}

	.inputW {
		width: 200PX !important;
	}

	.el-input--mini .el-input__inner {
		line-height: 38PX !important;
		height: 38PX !important;
		padding-left: 10PX;
		width: 150PX;
	}

	.el-input__inner {
		padding-left: 10px !important;
	}

	.el-form-item__content {
		margin-left: 100px !important;
	}

	/* 头像 */
	.previewBox {
		text-align: center;
		margin-left: 60px;
	}

	.preview {
		width: 150px;
		height: 150px;
		margin: 0px auto 20px auto;
		border-radius: 50%;
		border: 1px solid #ccc;
		background-color: #ccc;
		overflow: hidden;
	}

	.cropper {
		width: 260px;
		height: 260px;
	}

	.upimgbtn {
		text-align: right;
		display: inline-block;
		vertical-align: top;
	}
    .upimgbtn img{
		border-radius: 5px;
	}
	.upimgbtn .pimg {
		text-align: center;
		display: block;
	}
</style>
<style>
	.Ctitle .el-button--primary.is-plain:hover {
		background-color: #005dbe !important;
		color: #FFFFFF !important;
		border: 1px solid #005dbe;
	}

	.Ctitle .el-button--primary.is-plain {
		color: #005dbe;
		background: #ffffff;
		border-color: #005dbe;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/baseinfo.vue